import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    NO_CHANGE,
} from 'one-state-subject/src/types';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {
    setDepartmentsAction
} from '../../../../../../_local/one-state-department-athena/src/actions';
import { format } from 'one-util-date';

export const enum Types {
    GETALldepts_FETCH = "get-all-departments-fetch/athena",
    SETSELECTED_ATHENA = 'one-state-subject/setselected-athena',

}

/**
 * This function will fetch all departments
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchGetAllDepartmentsAthena = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, agentId, teamName, settings: {
            athenaendpoints: {
                getdepartmentinfo
            },
            compatible: { consolidated_api_invocation, contact_center_type },
        } } = context;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(Types.GETALldepts_FETCH,Types.SETSELECTED_ATHENA),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                const callGetAllDepartmentsAPI = () => {
                    let headers = new Headers();
                    const responsefromAPI = server.get({
                        headers: headers,
                        path: getdepartmentinfo
                    })
                        .then((responsegetalldepartments: any) => responsegetalldepartments)
                        .catch((getalldepartmentsres: any) => {
                            log.error(
                                "ccw-gadget,getalldepartments-athena",
                                "getalldepartments-athena", {
                                    getalldepartmentsres
                                }
                            );
                            let errorbuild: ErrorObject = {
                                source: "GetAllDepartments",
                                type: "error",
                                status: getalldepartmentsres?.status,
                                erroritems: getalldepartmentsres?.errors,
                                error_date: errorDate,
                                error_time: errorTime
                            };
                            return errorbuild;
                        })
                    log.debug(
                        "ccw-gadget,getalldepartments-athena",
                        "getalldepartments-athena response", {
                            responsefromAPI
                        });
                    return from(responsefromAPI)
                }
                //Calling callGetAllDepartmentsAPI function here
                //the reason is we need to use pipe function.
                return callGetAllDepartmentsAPI().
                    pipe(
                        map((responsereceived: any) => TransformResponse(responsereceived, context))).
                    pipe(
                        flatMap(responseAfterTransform => {
                            const actions: any = [];
                            if (responseAfterTransform.error) {
                                actions.push(addAction(responseAfterTransform.error));
                            } else {
                                actions.push(setDepartmentsAction(responseAfterTransform.departments));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);

